// extracted by mini-css-extract-plugin
export default {"NavDeskopt":"NavDeskopt_NavDeskopt__HAGHl","selected":"NavDeskopt_selected__f-3gs"};